import React from 'react';
import { Gallery, PageFaq } from '../sections/RestSections';
import { galleryFaqs } from '../mock';

export default function GalleryPage() {
  return (
    <main className="page gallery-page">
      <section className="page-hero">
        <div className="wrap">
          <p className="eyebrow">Our Work</p>
          <h1>Project Gallery</h1>
          <p className="lede">A look at real Victory Plumbing jobs across Savannah and the Coastal Empire &mdash; repairs, repipes, remodels, water heaters, backflow prevention, and commercial work.</p>
        </div>
      </section>
      <Gallery full />
      <PageFaq title="Project &amp; gallery FAQs" subtitle="About the work you see here and how we can help with yours." items={galleryFaqs} testid="gallery-faqs" />
    </main>
  );
}
